/* eslint-disable */
<template>
  <v-container id="learner-table-pagination">
      <el-pagination
        v-if="learnerDataLoaded"
        id="pagination"
        :current-page.sync="queryParamsLearners.page"
        :page-sizes="rowsPerPage"
        :page-size="queryParamsLearners.per_page"
        layout="sizes, prev, pager, next"
        :total="tableData.pagination.total"
        :disabled="learnersAjaxing || dialogOpen"
        @size-change="sizeChange"
        @prev-click="pageChange"
        @next-click="pageChange"
        @current-change="pageChange"
        >
      </el-pagination>
  </v-container>
</template>

<script>
import router from '../../router';
import { mapState, mapGetters, mapActions } from 'vuex';
import {
  waitForElementToDisplay
} from '@utilities';

export default {
  name: 'learner-table-pagination',
  components: {
  },
  data() {
    return {

    };
  },
  computed: {
    ...mapState('learners', [
      'playlists',
    ]),
    ...mapGetters([
      'activeView',
      'breadcrumbs',
      'dialogShow'
    ]),
    ...mapGetters('learners', [
      'activeViewLearners',
      'learnersAjaxing',
      'queryParamsLearners',
      'learnerDataLoaded',
      'classes',
      'bulbs',
      'gradebook',
      'studentinteraction',
      'lmb'
    ]),
    rowsPerPage () {
      if (this.tableData.pagination.total <= 20) return [this.tableData.pagination.total];
      if (this.tableData.pagination.total > 20 && this.tableData.pagination.total <= 40) return [20, this.tableData.pagination.total];
      if (this.tableData.pagination.total > 40 && this.tableData.pagination.total <= 60) return [20, 40, this.tableData.pagination.total];
      if (this.tableData.pagination.total > 60) return [20, 40, 60, this.tableData.pagination.total];
      if (this.tableData.pagination.total > 100 && (['Premade-Bulbs', 'My-Community'].includes(this.activeViewInstructor) ) ) return [20, 40, 60, 80, 100];
      return this.tableData.pagination.total;
    },
    tableData: function(){
      //rows per page based on active view
      switch(this.activeViewLearners) {
        case 'Classes':
          return this.classes;
        case 'Bulbs':
          return this.bulbs;
        case 'Gradebook':
          return this.gradebook;
        case 'Student-Interaction':
          return this.studentinteraction;
        case 'LMB-Monitor':
          return this.lmb;
        case 'Playlists':
          return this.playlists;
        default:
          console.log("Error: Please add to tableData in learner pagination switch statement");
          return 0;
      }
    },
    dialogOpen: function(){
      return(this.dialogShow.dash || this.dialogShow.toolbar || this.dialogShow.table || this.dialogShow.learner);
    }
  },
  methods:{
  ...mapActions('learners', [
  ]),
    sizeChange: function(event){
      //record page size change and sets query params
      let queryParams = {per_page:event, page:1};
      //sets query params to state, calls for data, and updates url
      this.$store.commit('learners/setQueryParams', queryParams);
      this.$store.dispatch('learners/getTableData');
      this.$store.dispatch('learners/updateUrl');
    },
    pageChange: function(event){
      //record page change and sets query params
      let queryParams = {page:event};
      //sets query params to state, calls for data, and updates url
      this.$store.commit('learners/setQueryParams', queryParams);
      this.$store.dispatch('learners/getTableData');
      this.$store.dispatch('learners/updateUrl');
    },
    createAriaLabel: function(){
      setTimeout(() => {
        let pagination = Array.from(document.getElementsByClassName('el-input__inner'));
        if (
          pagination
          && pagination.length
          ) {
            pagination[0].setAttribute('aria-label', 'Table pagination. Press enter to change the number of results displayed per table.')
          }
      }, 500)
    }
  },
  mounted() {
    this.createAriaLabel();
  },
  async updated() {
    const previousPageButton = await waitForElementToDisplay('.btn-prev');
    if (previousPageButton) previousPageButton[0].ariaLabel = 'Previous pagination page';
    const nextPageButton = await waitForElementToDisplay('.btn-next');
    if (nextPageButton) nextPageButton[0].ariaLabel = 'Next pagination page';
  },
};
</script>

<style scoped>
  #learner-table-pagination{
   padding-top: 0px;
   padding-bottom: 0px;
   height: 35px;
   display: flex;
   flex-flow: row;
   justify-content: center;
   align-items: center;
  }

  #pagination button {
    background-color: #fafafa !important;
  }

  #pagination ul {
    background-color: #fafafa !important;
  }

</style>


